/**
 * Format utilities for displaying data
 */

/**
 * Masks the last 5 digits of a phone number
 * Example: +998 90 123 45 67 → +998 90 12...
 */
export function maskPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return 'Noma\'lum';

  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');

  if (digits.length < 5) return phone;

  // Keep format but replace last 5 digits with ...
  const maskedDigits = digits.slice(0, -5) + '...';

  // Reformat: +998 90 123 45 67
  if (maskedDigits.startsWith('998') && maskedDigits.length >= 12) {
    return `+${maskedDigits.slice(0, 3)} ${maskedDigits.slice(3, 5)} ${maskedDigits.slice(5, 8)}...`;
  }

  // Fallback: just return masked
  return maskedDigits;
}

/**
 * Masks phone number only for published cars
 */
export function formatPhoneNumber(
  phone: string | null | undefined,
  isPublished: boolean = false
): string {
  if (isPublished) {
    return maskPhoneNumber(phone);
  }
  return phone || 'Noma\'lum';
}
